import React, { useContext, useState, useEffect } from "react";
import "./header.css";
import { FaBell } from "react-icons/fa6";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import notificationBell from "../../assets/images/notificationBell.svg";
import simpleBell from "../../assets/images/simpleBell.svg";
import darkNotificationBell from "../../assets/images/darkNotificationBell.svg";
import darkSimpleBell from "../../assets/images/darkSimpleBell.svg";
import { useNotification } from '../../hooks/useNotification';

import { IoSunny, IoMoon } from "react-icons/io5";

import useApiRequests from "../../hooks/useApiRequests";
import { useTheme } from "../../Context/ThemeContext";

interface HeaderProps {
  notifications: any;
}

export const Header: React.FC<HeaderProps> = ({ notifications }) => {
  const { theme, toggleTheme } = useTheme();
  const [userNotifications, setUserNotifications] = useState({new:[], old:[]})
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const { viewNotification, clearNotifications, getMyNotifications } = useApiRequests();
  const { notify } = useNotification();

  // React.useEffect(() => {
  //     console.log(notifications)
  // }, [])

  useEffect(()=> {
    setUserNotifications({
      new: notifications.new,
      old: notifications.old
    })
  },[])

  const getNotificationDate = (dateString: string) => {
    try {
      const newDate = new Date(dateString);
      var formatedDate =
        newDate.toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" }) +
        " " +
        newDate.toLocaleTimeString("pt-BR", { timeZone: "America/Sao_Paulo" });
      return formatedDate;
    } catch (error) {
      console.log(error);
      return "";
    }
  };

  const handleClearNotification = async () => {
     try {
        var data = await clearNotifications()
        if(data.success) {          
          setUserNotifications({
            new: data.data.new,
            old: data.data.old
          })
        }
        else {
          notify(data.msg, {type:"error"})
        }
     }
     catch (err) {
      console.log(err)
     }
  }

  const handleRedirectToAction = async (link: string, id: string) => {
    if (id !== "-1") {
      const data = await viewNotification(id);
    }
    // console.log("link", link)
    const base_url = window.location.origin;
    link = base_url + link;
    window.open(link, "_blank");
  };

  return (
    <div className="page-header">
      {/* <FaBell size={24} className={`header-notification-icon`} color='#fff' onClick={toggle}/>
            <div className='with-notification'></div> */}

      <div className="d-flex flex-direction-row gap-4 align-items-center">
        <button
          style={{
            border: "none",
            borderRadius: "1000px",
            width: 28,
            height: 28,
          }}
          className="btn-primary d-flex align-items-center justify-content-center"
          onClick={() => toggleTheme()}
        >
          {localStorage.getItem("mode") === "dark" ? (
            <IoSunny color="#FFF" size={64} />
          ) : (
            <IoMoon color="#FFF" size={64} />
          )}
        </button>
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle style={{ background: "none", border: "none" }}>
            {userNotifications?.new && userNotifications.new.length > 0 ? (
              <img
                src={
                  localStorage.getItem("mode") === "dark"
                    ? darkNotificationBell
                    : notificationBell
                }
                className={`header-notification-icon`}
              />
            ) : (
              <img
                src={
                  localStorage.getItem("mode") === "dark"
                    ? darkSimpleBell
                    : simpleBell
                }
                className={`header-notification-icon`}
              />
            )}
          </DropdownToggle>
          <DropdownMenu
            className="custom-dropdown-menu"
            style={{
              width: "500px",
              padding: "1rem",
              overflowY: "scroll",
              maxHeight: "500px",
            }}
          >
            <DropdownItem header className="d-flex align-items-center gap-3">
              <b style={{color:"gray"}} >Novas</b>
              {
                userNotifications?.new && userNotifications.new.length > 0 &&
                <button
                className="theme-text-color"
                 style={{
                   background:"none",
                   border:"none",
                   cursor:"pointer",
                   color:"gray",
                   fontWeight: "bold"
                   }}      
                   onClick={handleClearNotification}
                   >Limpar notificações</button>
              }

            </DropdownItem>
            {userNotifications?.new &&
              userNotifications.new.map((notification: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="notification-div"
                    onClick={() =>
                      handleRedirectToAction(
                        notification.customLink,
                        notification.id
                      )
                    }
                  >
                    <p>{notification.action}</p>
                    <span>{getNotificationDate(notification.created)}</span>
                  </div>
                );
              })}
            {userNotifications.new == null ||
              (userNotifications.new != null && userNotifications.new.length == 0 && (
                <p style={{ marginLeft: "1rem" }}>Sem novas notificações</p>
              ))}
            <DropdownItem divider />
            <DropdownItem header>
              <b>Antigas</b>
            </DropdownItem>
            {userNotifications?.old &&
              userNotifications.old.map((notification: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="notification-div"
                    onClick={() =>
                      handleRedirectToAction(notification.customLink, "-1")
                    }
                  >
                    <p>{notification.action}</p>
                    <span>{getNotificationDate(notification.created)}</span>
                  </div>
                );
              })}

              {
                (!userNotifications.new || userNotifications.new.length == 0) && (!userNotifications.old || userNotifications.old.length == 0) &&
                <DropdownItem></DropdownItem> 
              }
          </DropdownMenu>


        </Dropdown>
      </div>
    </div>
  );
};
